export default __webpack_public_path__ + "static/media/logo-somos.c8aa8b0c.svg";